import useVariant, { VariantTypes } from "src/hooks/useVariant";
import { hexToRGB } from "src/lib/colors";

const sizes = {
	default: "py-2 px-3 rounded-md",
	small: "py-1 px-2 text-[12px] rounded-md",
	xsmall: "py-1 px-1 text-[10px] rounded-sm",
};

export type BadgeSize = keyof typeof sizes;

interface BadgeProps {
	children?: any;
	bg?: string;
	color?: string;
	border?: string;
	variant?: VariantTypes;
	className?: string;
	style?: any;
	size: BadgeSize;
	onClick?: () => void;
	custom?: string;
}

const Badge = ({
	className,
	children,
	color,
	bg,
	border,
	variant,
	style,
	size,
	onClick,
	custom,
}: BadgeProps) => {
	const _variant = useVariant(variant);
	let _className =
		(className || "") +
		" w-max text-[14px] flex gap-1 items-center whitespace-nowrap ";

	if (!custom) {
		if (color && bg) {
			_className += `text-${color} bg-${bg}`;
		} else if (variant) {
			if (["green", "red"].includes(variant)) {
				_className += ` text-${variant} bg-${variant}-100`;
			} else {
				_className += _variant;
			}
		}
	} else {
		style = {
			...(style || {}),
			backgroundColor: hexToRGB(custom, 0.1),
			color: custom,
		};
	}

	if (border && !custom) {
		_className += ` border-${border} border-2`;
	}

	_className += ` ${sizes[size]}`;

	return (
		<strong {...{ style, onClick }} className={_className}>
			{children}
		</strong>
	);
};

Badge.defaultProps = {
	color: "primary",
	size: "default",
};

export default Badge;
